import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'add'
})
export class AddPipe implements PipeTransform {

    transform(value: string | number, args: number): number {
        if (value === '0' || !value) {
            value = 0;
        }

        if (!args) {
            args = 0;
        }

        if (typeof value === 'string') {
            const numberValue = parseInt(value);
            return numberValue + args;
        }

        return value + args;
    } // transform()

} // AddPipe
